import formatFileSize from './utils'

const messages = {
  _default: () => `Cette valeur n'est pas valide.`,
  after: (field, [target, inclusion]) => `doit être après ${inclusion ? 'ou égal à' : ''} ${target}.`,
  alpha_dash: () => 'le champ peut contenir des caractères alphanumériques ainsi que des tirets et des traits de soulignement.',
  alpha_num: () => 'le champ peut uniquement contenir des caractères alphanumériques.',
  alpha_spaces: () => `le champ peut uniquement contenir des caractères alphabétiques ainsi que des espaces.`,
  alpha: () => `le champ peut uniquement contenir des caractères alphabétiques.`,
  before: (field, [target, inclusion]) => `doit être avant ${inclusion ? 'ou égal à' : ''} ${target}.`,
  between: (field, [min, max]) => `le champ doit être compris entre ${min} et ${max}.`,
  confirmed: () =>
    `la confirmation ne correspond pas. `,
  credit_card: () => `le champ n'est pas valide. `,
  date_between: (field, [min, max]) =>
    `doit être compris entre ${min} et ${max}.`,
  date_format: (field, [format]) => `doit être au format ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `le champ doit être numérique et peut contenir ${
      !decimals || decimals === '*' ? '' : decimals
    } des points décimaux.`,
  digits: (field, [length]) =>
    `le champ doit être numérique et contenir exactement chiffres ${length}. `,
  dimensions: (field, [width, height]) =>
    `le champ doit être pixels ${width} et pixels ${height}`,
  email: () => `le champ doit contenir une adresse électronique valide.`,
  ext: () => `le champ doit être un fichier valide.`,
  image: () => `le champ doit être une image.`,
  in: () => `le champ doit être une valeur valide.`,
  integer: () => `le champ doit être un nombre entier.`,
  ip: () => `le champ doit être une adresse IP valide.`,
  length: (field, [length, max]) => {
    if(max) {
      return `la longueur du retour doit être comprise entre ${length} et ${max}.`
    }
    return `la longueur du retour doit être ${max}.`;
  },
  max: (field, [length]) => `le champ ne peut pas être supérieur à ${length} caractères.`,
  max_value: (field, [max]) => `le champ doit être de ${max} ou moins.`,
  mimes: () => `le champ doit avoir un type de fichier valide.`,
  min_value: (field, [min]) => `le champ doit être de ${min} ou plus.`,
  min: (field, [length]) => `le champ doit être d'au moins ${length} caractères.`,
  not_in: () => `le champ doit contenir une valeur valide.`,
  numeric: () => `le champ ne peut contenir que des caractères numériques.`,
  regex: () => `le format du champ n'est pas valide.`,
  required: () => `le champ est obligatoire.`,
  size: (field, [size]) =>
    `la taille doit être inférieure à ${formatFileSize(size)}`,
  url: () => `le champ ne contient pas d'URL valide.`,
  fullName: () => `n'est pas valide (nom, prénom et max. 120 caractères)`,
  emailInput: () => 'le champ doit contenir une adresse électronique valide.',
  fullNamePerCountry: () => `n'est pas valide (nom, prénom et max. 18 caractères)`,
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'fr_be',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/fr_be.js